module.exports = __webpack_public_path__ + "img/masterial.09fff230.png";